import {safeUnreachableCase} from '~/utils/unreachableCase'
import HgArticleHeroMediumVariantComponents, {
  type HgArticleHeroMediumVariantProps,
} from './HgArticleHeroMediumVariantComponents'
import HgArticleHeroNoAsset, {
  type HgArticleHeroNoAssetProps,
} from '../HgArticleHeroNoAsset'

type HgArticleHeroMediumVariants =
  | HgArticleHeroMediumVariantProps
  | HgArticleHeroNoAssetProps

export type HgArticleHeroMediumProps = {
  level: 'medium'
  className?: string
  hasTheme?: boolean
} & HgArticleHeroMediumVariants

export default function HgArticleHeroMedium(props: HgArticleHeroMediumProps) {
  switch (props.assetType) {
    case 'horizontal':
    case 'square':
    case 'vertical':
      return <HgArticleHeroMediumVariantComponents {...props} />
    case 'none':
      return <HgArticleHeroNoAsset {...props} />
    default:
      return safeUnreachableCase(props, null)
  }
}
